import {Permissions as P,type Permission,type StaffSession} from '@myfm/domain';
import {withBuildingScope} from './building-scope';

type FeaturePage={path:string;label:string;workspace:string;permission:Permission;scope:'building'|'portfolio'};
const page=(path:string,label:string,workspace:string,permission:Permission,scope:'building'|'portfolio'='building'):FeaturePage=>({path:'/alpha/'+path,label,workspace,permission,scope});
/** Existing feature routes use their owning workspace and original entry capability.
 * This changes navigation only; feature flags and route/API access remain authoritative. */
export const featureWorkspacePages:readonly FeaturePage[]=[
 page('budget-publication','Budget publication','finance',P.ManageServiceChargeFinance),
 page('director-publication','Share a director decision','governance',P.ManageGovernance),
 page('conveyancing','Conveyancing packs','property_admin',P.ViewCommunications),
 page('consents','Alterations applications','property_admin',P.ViewCommunications),
 page('resident-cases','Lease breach and nuisance','communications',P.ViewCommunications),
 page('company','Company administration','governance',P.ViewGovernance),
 page('utility-exceptions','Utility exceptions','assets',P.ViewMaster),
 page('meetings','Meetings and resolutions','governance',P.ViewGovernance),
 page('board-packs','Board packs','governance',P.ViewOperationalReporting),
 page('supplier-performance','Supplier performance','suppliers',P.ManageContractors),
 page('reserve-forecasts','Reserve forecasts','finance',P.ViewFinance),
 page('building-assistant','Building evidence assistant','assets',P.ViewMaster),
 page('contract-renewals','Contract renewal decisions','suppliers',P.ManageContractors),
 page('supplier-renewals','Supplier evidence renewals','suppliers',P.ManageContractors,'portfolio'),
 page('resident-appointments','Resident appointments','operations_compliance',P.ManageWork),
 page('building-notices','Building notices','communications',P.ManageCommunications),
 page('payment-plans','Payment-plan requests','finance',P.ApproveServiceChargeFinance),
 page('bank-feeds','Sandbox bank feed','finance',P.ManageBankReconciliation),
 page('complaints','Complaint reviews','communications',P.ViewCommunications),
 page('incidents','Building incidents','repairs',P.ViewWork),
 page('warranties','Warranty and defect recovery','repairs',P.ViewWork),
 page('refunds','Refund requests','finance',P.ViewFinance),
 page('information','Information requests','communications',P.ViewCommunications),
 page('polls','Resident polls','communications',P.ViewCommunications),
 page('planning','Management planning','governance',P.ViewOperationalReporting),
 page('handovers','Outgoing handovers','property_admin',P.ViewCommunications),
 page('whatsapp','WhatsApp correspondence','communications',P.ViewCommunications),
 page('rule-simulations','Automation preview','administration',P.ViewPlatformOperations,'portfolio'),
 page('households','Leaseholder contact submissions','property_admin',P.ViewMaster),
 page('card-payments','Card payment reconciliation','finance',P.ViewFinance),
 page('year-end','Year-end accountant review','finance',P.ViewAccountingReports),
 page('year-end-balancing','Year-end balancing','finance',P.ViewFinance),
];
export const featureWorkspacePage=(pathname:string)=>featureWorkspacePages.find(item=>item.path===pathname);
export function featureWorkspaceLinks(session:StaffSession,workspace:string,enabled:boolean,currentPath:string){
 const building=session.effectiveScope.kind==='building'?session.effectiveScope.id:undefined;
 return featureWorkspacePages.filter(item=>item.workspace===workspace&&session.capabilities.includes(item.permission)
   &&(item.scope==='building'?Boolean(building):!building)&&enabled
   // This sandbox has its own service flag, not exposed by the general feature flag.
   &&item.path!=='/alpha/bank-feeds')
  .map(item=>({id:withBuildingScope(item.path,building),href:withBuildingScope(item.path,building),label:item.label,permission:item.permission,group:'Registers' as const}));
}
